import ApprovedStudents from './ApprovedStudents';

export default ApprovedStudents;
